// Keep a global cache of simulation folder objects.
// This is just temporary until the routing state is moved
// to vuex.
const cache = {};
export default cache;
